let audioCtx = null;
let unlockBound = false;

function ensureCtx() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!audioCtx) audioCtx = new Ctx();
  return audioCtx;
}

function resumeCtx() {
  try {
    const ctx = ensureCtx();
    if (ctx?.state === 'suspended') ctx.resume().catch(() => {});
  } catch {
    /* ignore */
  }
}

/** Llamar desde un click/touch real (PIN, botón). */
export function primePedidoStatusSound() {
  resumeCtx();
}

/**
 * Registra un listener para crear/reanudar AudioContext solo tras gesto del usuario.
 * No crear el contexto en mount (Chrome lo bloquea y llena la consola).
 */
export function unlockPedidoStatusSound() {
  if (audioCtx?.state === 'running') return;
  if (unlockBound) return;
  unlockBound = true;
  const unlock = () => {
    resumeCtx();
    window.removeEventListener('pointerdown', unlock);
    window.removeEventListener('keydown', unlock);
    window.removeEventListener('touchstart', unlock);
    unlockBound = false;
  };
  window.addEventListener('pointerdown', unlock, { once: true, passive: true });
  window.addEventListener('keydown', unlock, { once: true });
  window.addEventListener('touchstart', unlock, { once: true, passive: true });
}

const ESTADO_MSG = {
  confirmado: 'Pedido aprobado',
  en_preparacion: 'Pedido en preparación',
  entregado: 'Pedido completado en bodega',
  cancelado: 'Pedido rechazado',
};

export function estadoChangeMessage(estado) {
  return ESTADO_MSG[estado] || `Estado: ${estado}`;
}

export function playPedidoStatusSound(estado) {
  let ctx;
  try {
    ctx = ensureCtx();
  } catch {
    return;
  }
  if (!ctx) return;
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  const t0 = ctx.currentTime;
  const tone = (freq, start, dur, vol = 0.2) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    osc.connect(gain);
    gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0.0001, t0 + start);
    gain.gain.exponentialRampToValueAtTime(vol, t0 + start + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + start + dur);
    osc.start(t0 + start);
    osc.stop(t0 + start + dur + 0.05);
  };
  if (estado === 'cancelado') {
    tone(440, 0, 0.2, 0.18);
    tone(330, 0.22, 0.25, 0.15);
  } else {
    tone(523, 0, 0.12);
    tone(659, 0.14, 0.12);
    tone(784, 0.28, 0.16);
  }
}
